import React from 'react'
import Deals from './Deals'

export const Newdeals = () => {
  return (
    <Deals/>
  )
}
